export default __webpack_public_path__ + "static/bg-cs-zappi-8773764b9bfab353473a6b447515edc9.webp";